import React, { useState } from 'react';
import '../styles/StudentPaymentList.css';

const StudentPaymentList = () => {
  const [selectedClass, setSelectedClass] = useState('');
  const [studentData, setStudentData] = useState([]);
  const classOptions = ['Nursery', 'LKG', 'UKG', ...Array.from({ length: 10 }, (_, i) => `${i + 1}`)];

  const handleSubmit = async (e) => {
    e.preventDefault();
    const res = await fetch(
      `/backend/api/get_student_payment_list.php?class_name=${selectedClass}`,
      { credentials: 'include' }
    );
    const data = await res.json();
    setStudentData(data);
  };

  const printStudentPaymentTable = () => {
    const tableHTML = document.getElementById('print-section').innerHTML;
    const newWin = window.open('', '', 'width=1200,height=700');
    newWin.document.write(`
      <html>
        <head>
          <title>Student Payment Report</title>
          <style>
            body {
              font-family: Arial, sans-serif;
              padding: 20px;
            }
            h2 {
              text-align: center;
              margin-bottom: 10px;
            }
            .logo {
              width: 80px;
              height: auto;
              display: block;
              margin: 0 auto 10px auto;
            }
            table {
              width: 100%;
              border-collapse: collapse;
              font-size: 12px;
              margin-top: 10px;
            }
            th, td {
              border: 1px solid #999;
              padding: 6px;
              text-align: left;
              font-size: 11px;
            }
            th {
              background-color: #f0f0f0;
            }
            tfoot td {
              font-weight: bold;
              background-color: #f9f9f9;
            }
            .footer {
              text-align: center;
              margin-top: 40px;
              font-size: 12px;
              color: #666;
            }
          </style>
        </head>
        <body>
          <img src="/school-logo.jpeg" alt="School Logo" class="logo" />
          <h2>Shree Maharaja English Medium Public School - Student Payment Report (${selectedClass})</h2>
          ${tableHTML}
          <div class="footer">Printed on: ${new Date().toLocaleDateString()}</div>
        </body>
      </html>
    `);
    newWin.document.close();
    newWin.focus();
    newWin.print();
    newWin.close();
  };

  const total = {
    feesPaid: studentData.reduce((sum, s) => sum + Number(s.fees_paid || 0), 0),
    feesDue: studentData.reduce((sum, s) => sum + Number(s.fees_due || 0), 0),
    concession: studentData.reduce((sum, s) => sum + Number(s.concession_amount || 0), 0),
    vanFee: studentData.reduce((sum, s) => sum + Number(s.van_fee || 0), 0),
    vanDue: studentData.reduce((sum, s) => sum + Number(s.van_due || 0), 0),
    oldFeeDue: studentData.reduce((sum, s) => sum + Number(s.old_fee_due || 0), 0),
    oldFeePendingDue: studentData.reduce((sum, s) => sum + Number(s.old_fee_pending_due || 0), 0),
  };

  return (
    <div className="fje-container">
      <div className="fje-card">
        <h2 className="fje-heading">📋 Student Payment List</h2>

        <form onSubmit={handleSubmit} className="fje-form">
          <label htmlFor="class" className="fje-label">
            Select Class
          </label>
          <select
            id="class"
            value={selectedClass}
            onChange={(e) => setSelectedClass(e.target.value)}
            className="fje-select"
            required
          >
            <option value="">-- Select Class --</option>
            {classOptions.map((cls) => (
              <option key={cls} value={cls}>{cls}</option>
            ))}
          </select>

          <button type="submit" className="fje-button">Submit</button>
        </form>
      </div>

      {studentData.length > 0 && (
        <>
          <div className="fje-print-button-wrapper">
            <button onClick={printStudentPaymentTable} className="fje-button">🖨️ Print Table</button>
          </div>

          <div id="print-section" className="fje-table-wrapper">
            <table className="fje-table">
              <thead>
                <tr>
                  <th>Student Name</th>
                  <th>Father Name</th>
                  <th>Phone Number</th>
                  <th>Fees Paid</th>
                  <th>Fees Due</th>
                  <th>Concession</th>
                  <th>Van Fee</th>
                  <th>Due Van Fee</th>
                  <th>Old Fees Dues</th>
                  <th>Old Fees Pending Due</th>
                </tr>
              </thead>
              <tbody>
                {studentData.map((student, index) => (
                  <tr key={index}>
                    <td>{student.full_name}</td>
                    <td>{student.father_name}</td>
                    <td>{student.phone_number}</td>
                    <td>₹{student.fees_paid}</td>
                    <td>₹{student.fees_due}</td>
                    <td>{student.concession_amount ? `₹${student.concession_amount}` : ''}</td>
                    <td>₹{student.van_fee}</td>
                    <td>₹{student.van_due}</td>
                    <td>₹{student.old_fee_due || 0}</td>
                    <td>₹{student.old_fee_pending_due || 0}</td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr>
                  <td colSpan="3"><strong>Total</strong></td>
                  <td><strong>₹{total.feesPaid}</strong></td>
                  <td><strong>₹{total.feesDue}</strong></td>
                  <td><strong>₹{total.concession}</strong></td>
                  <td><strong>₹{total.vanFee}</strong></td>
                  <td><strong>₹{total.vanDue}</strong></td>
                  <td><strong>₹{total.oldFeeDue}</strong></td>
                  <td><strong>₹{total.oldFeePendingDue}</strong></td>
                </tr>
              </tfoot>
            </table>
          </div>
        </>
      )}
    </div>
  );
};

export default StudentPaymentList;
